import { Tag } from '@cian/components';
import * as React from 'react';

import { EElevators } from '../../../../json_query';
import { IElevatorsMinCountTag } from '../../../state/tags/definitions/elevators_min_count';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IElevatorsMinCountTagItemProps {
  tag: IElevatorsMinCountTag;
  withNewTag?: boolean;
  isNewAdvancedFilters: boolean;

  onDeleteClick(): void;
}

const elevatorsCountMap = {
  [EElevators.One]: '1',
  [EElevators.Two]: '2',
  [EElevators.Three]: '3',
  [EElevators.Four]: '4',
};

export const ElevatorsMinCountTagItem = ({
  tag,
  onDeleteClick,
  isNewAdvancedFilters,
  withNewTag,
}: IElevatorsMinCountTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === EElevators.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {isNewAdvancedFilters ? 'Есть лифт' : `Лифтов минимум ${elevatorsCountMap[tag.value]}`}
    </TagComponent>
  );
};
